import { c as _c } from "react/compiler-runtime";
import React from "react";
import { CirclePlay } from "lucide-react";
type Size = "sm" | "md" | "lg" | "xl";
interface VideoPlayIndicatorProps {
  size?: Size;
  className?: string;
}
const ICON_SIZES: Record<Size, string> = {
  sm: "w-8 h-8",
  md: "w-12 h-12 sm:w-16 sm:h-16",
  lg: "w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24",
  xl: "w-20 h-20 sm:w-24 sm:h-24 md:w-32 md:h-32"
};

/**
 * Centered play affordance rendered over a video thumbnail. Mirrors the
 * `MainIcon` component in `fansunited-sports-ui` so cards using `ContentCard`
 * (which draws its own MainIcon when `content.type === "video"`) and custom
 * image surfaces present the same visual.
 */
export function VideoPlayIndicator(t0) {
  const $ = _c(2);
  const {
    size: t1,
    className: t2
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  const className = t2 === undefined ? "" : t2;
  const t3 = `${ICON_SIZES[size]} text-white drop-shadow-lg ${className}`;
  let t4;
  if ($[0] !== t3) {
    t4 = <div className="absolute inset-0 z-10 pointer-events-none flex items-center justify-center" aria-hidden="true"><CirclePlay className={t3} strokeWidth={1.5} /></div>;
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  return t4;
}